export default "__VITE_ASSET__CHHXGEjC__"